import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import HomeFooter from '@/pages/home/components/HomeFooter';
import StorefrontHero from './components/StorefrontHero';
import SpaceNarrative from './components/SpaceNarrative';

export default function Storefront() {
  useScrollAnimation();

  return (
    <main className="bg-black min-h-screen">
      <StorefrontHero />
      <SpaceNarrative />
      <HomeFooter />
    </main>
  );
}
